// removed by extract-text-webpack-plugin
module.exports = {"review-breakdown__title":"review-breakdown_review-breakdown__title--3X6gepMC","reviewBreakdownTitle":"review-breakdown_review-breakdown__title--3X6gepMC"};


//////////////////
// WEBPACK FOOTER
// ./components/profile-right-section/src/styles/review-breakdown.scss
// module id = 2340
// module chunks = 0